import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconBellSvg } from "./IconBellSvg.mjs";
const IconBell = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconBellSvg, ...iconProps });
};
export {
  IconBell
};
